// src/components/Preloader.jsx
import React from 'react';
import preloaderImg from '@/assets/preloader.png';

const Preloader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <img
        src={preloaderImg}
        alt="Carregando..."
        className="w-32 h-32 animate-pulse rounded-full shadow-lg"
      />
    </div>
  );
};

export default Preloader;
